module.exports = __webpack_public_path__ + "static/media/form_place_holder.93598c75.svg";